import { render, staticRenderFns } from "./ActiveLeaveCard.vue?vue&type=template&id=5c01272e"
import script from "./ActiveLeaveCard.vue?vue&type=script&lang=js"
export * from "./ActiveLeaveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports